module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Fees List")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editModal(_vm.softwareTimings)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm"
  }, [_c('tr', [_c('th', [_vm._v("Member Fees")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.memberFee))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Member Fees Type")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.memberFeeType))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-sm"
  }, [_c('tr', [_c('th', [_vm._v("Employee/Agent Fees")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.agentFee))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Employee/Agent Fees Type")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.agentFeeType))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-sm"
  }, [_c('tr', [_c('th', [_vm._v("Per File Charge")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.fileCharge))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Per File Charge Type")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.fees.fileChargeType))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of Fees\r\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-xl"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberFee),
      expression: "form.memberFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberFee'),
    },
    attrs: {
      "type": "text",
      "name": "memberFee"
    },
    domProps: {
      "value": (_vm.form.memberFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberFee"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberFeeType),
      expression: "form.memberFeeType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberFeeType'),
    },
    attrs: {
      "name": "memberFeeType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "memberFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberFeeType"
    }
  })], 1)])])])])])])]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-xl1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentFee),
      expression: "form.agentFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentFee'),
    },
    attrs: {
      "type": "text",
      "name": "agentFee"
    },
    domProps: {
      "value": (_vm.form.agentFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agentFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentFee"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentFeeType),
      expression: "form.agentFeeType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentFeeType'),
    },
    attrs: {
      "name": "agentFeeType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "agentFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentFeeType"
    }
  })], 1)])])])])])])]), _vm._v(" "), _vm._m(11)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-xl2"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fileCharge),
      expression: "form.fileCharge"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fileCharge'),
    },
    attrs: {
      "type": "text",
      "name": "fileCharge"
    },
    domProps: {
      "value": (_vm.form.fileCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fileCharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fileCharge"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fileChargeType),
      expression: "form.fileChargeType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fileChargeType'),
    },
    attrs: {
      "name": "fileChargeType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "fileChargeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fileChargeType"
    }
  })], 1)])])])])])])]), _vm._v(" "), _vm._m(15)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Member Fees Details")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modal-xl"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Employee/Agent Fees Details")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modal-xl"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("File Charge")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modal-xl"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Master Fees Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Fees "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Fees Type\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CANCEL\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Master Fees Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Agent Fees "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Agent Fee Type "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CANCEL\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Master Fees Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Charge "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Charge Type\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CANCEL\r\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d076036!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/FeesMaster.vue
// module id = 778
// module chunks = 0